export default "__VITE_ASSET__CFNp5bsb__"